const CATEGORIES = [
    { code: 'A', name: 'Vermögen', kind: 'asset', children: [{ code: 'A1', name: 'Kasse und Bank' }, { code: 'A2', name: 'Forderungen' }, { code: 'A3', name: 'Vorsteuer' }] },
    { code: 'P', name: 'Verbindlichkeiten', kind: 'liability', children: [{ code: 'P1', name: 'Verbindlichkeiten und Darlehen' }, { code: 'P2', name: 'Umsatzsteuer' }] },
    { code: 'E', name: 'Eigenkapital und Privat', kind: 'equity', children: [{ code: 'E1', name: 'Eigenkapital' }, { code: 'E2', name: 'Privatentnahmen und Privateinlagen' }] },
    { code: 'R', name: 'Erlöse', kind: 'revenue', children: [{ code: 'R1', name: 'Erlöse aus Leistungen und Lieferungen' }, { code: 'R2', name: 'Sonstige Erträge' }] },
    { code: 'W', name: 'Material und Wareneinsatz', kind: 'expense', children: [{ code: 'W1', name: 'Wareneinkauf' }, { code: 'W2', name: 'Fremdleistungen' }] },
    {
        code: 'B',
        name: 'Betriebliche Aufwendungen',
        kind: 'expense',
        children: [
            { code: 'B1', name: 'Personal' },
            { code: 'B2', name: 'Raumkosten' },
            { code: 'B3', name: 'Fahrzeugkosten' },
            { code: 'B4', name: 'Werbung und Reisen' },
            { code: 'B5', name: 'Verwaltung und Beratung' },
            { code: 'B6', name: 'Versicherungen und Beiträge' },
            { code: 'B7', name: 'Abschreibungen' },
            { code: 'B8', name: 'Sonstiges' },
        ],
    },
];
const STANDARD = {
    framework: 'none',
    categories: CATEGORIES,
    accounts: [
        ['1000', 'Kasse', 'A1'],
        ['1100', 'Bank (Girokonto)', 'A1'],
        ['1200', 'Forderungen aus Lieferungen und Leistungen', 'A2'],
        ['1300', 'Abziehbare Vorsteuer 19 %', 'A3'],
        ['1310', 'Abziehbare Vorsteuer 7 %', 'A3'],
        ['2000', 'Verbindlichkeiten aus Lieferungen und Leistungen', 'P1'],
        ['2100', 'Umsatzsteuer 19 %', 'P2'],
        ['2110', 'Umsatzsteuer 7 %', 'P2'],
        ['2200', 'Umsatzsteuer-Zahllast', 'P2'],
        ['2300', 'Darlehen', 'P1'],
        ['3000', 'Eigenkapital', 'E1'],
        ['3100', 'Privatentnahmen', 'E2'],
        ['3200', 'Privateinlagen', 'E2'],
        ['4000', 'Erlöse 19 % Umsatzsteuer', 'R1', 'S19'],
        ['4010', 'Erlöse 7 % Umsatzsteuer', 'R1', 'S7'],
        ['4020', 'Erlöse steuerfrei', 'R1', 'Z0'],
        ['4030', 'Erlöse, Steuerschuld beim Leistungsempfänger (§ 13b UStG)', 'R1', 'AE'],
        ['4040', 'Erlöse als Kleinunternehmer (§ 19 UStG)', 'R1', 'KU'],
        ['4900', 'Sonstige betriebliche Erträge', 'R2'],
        ['5000', 'Wareneinkauf 19 % Vorsteuer', 'W1', 'S19'],
        ['5010', 'Wareneinkauf 7 % Vorsteuer', 'W1', 'S7'],
        ['5100', 'Fremdleistungen', 'W2', 'S19'],
        ['6000', 'Löhne und Gehälter', 'B1'],
        ['6010', 'Sozialabgaben', 'B1'],
        ['6100', 'Miete', 'B2'],
        ['6110', 'Strom, Gas und Wasser', 'B2'],
        ['6120', 'Reinigung', 'B2'],
        ['6200', 'Kfz-Betriebskosten', 'B3'],
        ['6210', 'Kfz-Steuer und Versicherung', 'B3'],
        ['6220', 'Kfz-Reparaturen', 'B3'],
        ['6300', 'Werbekosten', 'B4'],
        ['6310', 'Reisekosten', 'B4'],
        ['6320', 'Bewirtungskosten', 'B4'],
        ['6400', 'Bürobedarf', 'B5'],
        ['6410', 'Telefon und Internet', 'B5'],
        ['6420', 'Porto', 'B5'],
        ['6430', 'Software und Lizenzen', 'B5'],
        ['6440', 'Steuerberatung und Buchführung', 'B5'],
        ['6450', 'Rechts- und Beratungskosten', 'B5'],
        ['6500', 'Versicherungen', 'B6'],
        ['6510', 'Beiträge', 'B6'],
        ['6700', 'Abschreibungen', 'B7'],
        ['6710', 'Geringwertige Wirtschaftsgüter', 'B7'],
        ['6900', 'Bankgebühren', 'B8'],
        ['6990', 'Sonstige Aufwendungen', 'B8'],
    ],
    taxAccounts: [
        { code: 'S19', revenueAccount: '4000', taxAccount: '2100' },
        { code: 'S7', revenueAccount: '4010', taxAccount: '2110' },
        { code: 'Z0', revenueAccount: '4020', taxAccount: null },
        { code: 'E', revenueAccount: '4020', taxAccount: null },
        { code: 'KU', revenueAccount: '4040', taxAccount: null },
        { code: 'AE', revenueAccount: '4030', taxAccount: null },
        { code: 'K', revenueAccount: '4020', taxAccount: null },
        { code: 'G', revenueAccount: '4020', taxAccount: null },
        { code: 'O', revenueAccount: '4020', taxAccount: null },
    ],
};
const SKR03 = {
    framework: 'SKR03',
    categories: CATEGORIES,
    accounts: [
        ['1000', 'Kasse', 'A1'],
        ['1200', 'Bank', 'A1'],
        ['1400', 'Forderungen aus Lieferungen und Leistungen', 'A2'],
        ['1571', 'Abziehbare Vorsteuer 7 %', 'A3'],
        ['1576', 'Abziehbare Vorsteuer 19 %', 'A3'],
        ['0630', 'Verbindlichkeiten gegenüber Kreditinstituten', 'P1'],
        ['1600', 'Verbindlichkeiten aus Lieferungen und Leistungen', 'P1'],
        ['1771', 'Umsatzsteuer 7 %', 'P2'],
        ['1776', 'Umsatzsteuer 19 %', 'P2'],
        ['1780', 'Umsatzsteuer-Vorauszahlungen', 'P2'],
        ['1800', 'Privatentnahmen allgemein', 'E2'],
        ['1890', 'Privateinlagen', 'E2'],
        ['8200', 'Erlöse', 'R1', 'Z0'],
        ['8300', 'Erlöse 7 % Umsatzsteuer', 'R1', 'S7'],
        ['8400', 'Erlöse 19 % Umsatzsteuer', 'R1', 'S19'],
        ['8120', 'Steuerfreie Umsätze nach § 4 Nr. 1a UStG', 'R1', 'G'],
        ['8125', 'Steuerfreie innergemeinschaftliche Lieferungen nach § 4 Nr. 1b UStG', 'R1', 'K'],
        ['8195', 'Erlöse als Kleinunternehmer nach § 19 UStG', 'R1', 'KU'],
        ['8337', 'Erlöse, bei denen der Leistungsempfänger die Steuer schuldet (§ 13b UStG)', 'R1', 'AE'],
        ['2700', 'Sonstige betriebliche Erträge', 'R2'],
        ['3300', 'Wareneingang 7 % Vorsteuer', 'W1', 'S7'],
        ['3400', 'Wareneingang 19 % Vorsteuer', 'W1', 'S19'],
        ['3100', 'Fremdleistungen', 'W2', 'S19'],
        ['4120', 'Gehälter', 'B1'],
        ['4130', 'Gesetzliche soziale Aufwendungen', 'B1'],
        ['4210', 'Miete', 'B2'],
        ['4240', 'Gas, Strom, Wasser', 'B2'],
        ['4250', 'Reinigung', 'B2'],
        ['4510', 'Kfz-Steuer', 'B3'],
        ['4520', 'Kfz-Versicherungen', 'B3'],
        ['4530', 'Laufende Kfz-Betriebskosten', 'B3'],
        ['4540', 'Kfz-Reparaturen', 'B3'],
        ['4600', 'Werbekosten', 'B4'],
        ['4650', 'Bewirtungskosten', 'B4'],
        ['4660', 'Reisekosten Arbeitnehmer', 'B4'],
        ['4670', 'Reisekosten Unternehmer', 'B4'],
        ['4806', 'Wartungskosten für Hard- und Software', 'B5'],
        ['4910', 'Porto', 'B5'],
        ['4920', 'Telefon', 'B5'],
        ['4925', 'Internetkosten', 'B5'],
        ['4930', 'Bürobedarf', 'B5'],
        ['4940', 'Zeitschriften und Bücher', 'B5'],
        ['4950', 'Rechts- und Beratungskosten', 'B5'],
        ['4955', 'Buchführungskosten', 'B5'],
        ['4360', 'Versicherungen', 'B6'],
        ['4380', 'Beiträge', 'B6'],
        ['4830', 'Abschreibungen auf Sachanlagen', 'B7'],
        ['4855', 'Sofortabschreibung geringwertiger Wirtschaftsgüter', 'B7'],
        ['4900', 'Sonstige betriebliche Aufwendungen', 'B8'],
        ['4970', 'Nebenkosten des Geldverkehrs', 'B8'],
    ],
    taxAccounts: [
        { code: 'S19', revenueAccount: '8400', taxAccount: '1776' },
        { code: 'S7', revenueAccount: '8300', taxAccount: '1771' },
        { code: 'Z0', revenueAccount: '8200', taxAccount: null },
        { code: 'E', revenueAccount: '8200', taxAccount: null },
        { code: 'KU', revenueAccount: '8195', taxAccount: null },
        { code: 'AE', revenueAccount: '8337', taxAccount: null },
        { code: 'K', revenueAccount: '8125', taxAccount: null },
        { code: 'G', revenueAccount: '8120', taxAccount: null },
    ],
};
const SKR04 = {
    framework: 'SKR04',
    categories: CATEGORIES,
    accounts: [
        ['1600', 'Kasse', 'A1'],
        ['1800', 'Bank', 'A1'],
        ['1200', 'Forderungen aus Lieferungen und Leistungen', 'A2'],
        ['1401', 'Abziehbare Vorsteuer 7 %', 'A3'],
        ['1406', 'Abziehbare Vorsteuer 19 %', 'A3'],
        ['3150', 'Verbindlichkeiten gegenüber Kreditinstituten', 'P1'],
        ['3300', 'Verbindlichkeiten aus Lieferungen und Leistungen', 'P1'],
        ['3801', 'Umsatzsteuer 7 %', 'P2'],
        ['3806', 'Umsatzsteuer 19 %', 'P2'],
        ['3820', 'Umsatzsteuer-Vorauszahlungen', 'P2'],
        ['2100', 'Privatentnahmen allgemein', 'E2'],
        ['2180', 'Privateinlagen', 'E2'],
        ['4200', 'Erlöse', 'R1', 'Z0'],
        ['4300', 'Erlöse 7 % Umsatzsteuer', 'R1', 'S7'],
        ['4400', 'Erlöse 19 % Umsatzsteuer', 'R1', 'S19'],
        ['4120', 'Steuerfreie Umsätze nach § 4 Nr. 1a UStG', 'R1', 'G'],
        ['4125', 'Steuerfreie innergemeinschaftliche Lieferungen nach § 4 Nr. 1b UStG', 'R1', 'K'],
        ['4195', 'Erlöse als Kleinunternehmer nach § 19 UStG', 'R1', 'KU'],
        ['4337', 'Erlöse, bei denen der Leistungsempfänger die Steuer schuldet (§ 13b UStG)', 'R1', 'AE'],
        ['4830', 'Sonstige betriebliche Erträge', 'R2'],
        ['5300', 'Wareneingang 7 % Vorsteuer', 'W1', 'S7'],
        ['5400', 'Wareneingang 19 % Vorsteuer', 'W1', 'S19'],
        ['5900', 'Fremdleistungen', 'W2', 'S19'],
        ['6020', 'Gehälter', 'B1'],
        ['6110', 'Gesetzliche soziale Aufwendungen', 'B1'],
        ['6310', 'Miete', 'B2'],
        ['6325', 'Gas, Strom, Wasser', 'B2'],
        ['6330', 'Reinigung', 'B2'],
        ['6510', 'Kfz-Steuer', 'B3'],
        ['6520', 'Kfz-Versicherungen', 'B3'],
        ['6530', 'Laufende Kfz-Betriebskosten', 'B3'],
        ['6540', 'Kfz-Reparaturen', 'B3'],
        ['6600', 'Werbekosten', 'B4'],
        ['6640', 'Bewirtungskosten', 'B4'],
        ['6650', 'Reisekosten Arbeitnehmer', 'B4'],
        ['6800', 'Porto', 'B5'],
        ['6805', 'Telefon', 'B5'],
        ['6815', 'Bürobedarf', 'B5'],
        ['6820', 'Zeitschriften und Bücher', 'B5'],
        ['6825', 'Rechts- und Beratungskosten', 'B5'],
        ['6830', 'Buchführungskosten', 'B5'],
        ['6400', 'Versicherungen', 'B6'],
        ['6420', 'Beiträge', 'B6'],
        ['6220', 'Abschreibungen auf Sachanlagen', 'B7'],
        ['6260', 'Sofortabschreibung geringwertiger Wirtschaftsgüter', 'B7'],
        ['6300', 'Sonstige betriebliche Aufwendungen', 'B8'],
        ['6855', 'Nebenkosten des Geldverkehrs', 'B8'],
    ],
    taxAccounts: [
        { code: 'S19', revenueAccount: '4400', taxAccount: '3806' },
        { code: 'S7', revenueAccount: '4300', taxAccount: '3801' },
        { code: 'Z0', revenueAccount: '4200', taxAccount: null },
        { code: 'E', revenueAccount: '4200', taxAccount: null },
        { code: 'KU', revenueAccount: '4195', taxAccount: null },
        { code: 'AE', revenueAccount: '4337', taxAccount: null },
        { code: 'K', revenueAccount: '4125', taxAccount: null },
        { code: 'G', revenueAccount: '4120', taxAccount: null },
    ],
};
export const CHART_TEMPLATES = { none: STANDARD, SKR03, SKR04 };
//# sourceMappingURL=chart-templates.js.map